import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { Typography, Grid } from "@material-ui/core";
import { MuiChip, MuiGrid } from "./style";
import { useStore } from "../../store";
import { getSearchList } from "../../utils/storage";
import { SearchRecommendContainer } from "./style";
import { TranslationJSX } from "../../utils/Translation";
import SearchRecommendTagList from "./SearchRecommendTagList";
import firebaseEvent from "../../utils/firebaseEvent";
import { setSelectType } from "../../utils/storage";

const SearchRecommend = () => {
  const history = useHistory();
  const searches = getSearchList();
  const {
    searchStore: {
      onUpdateCurrentSearch,
      autoCompleteState: { list, isEmpty, type },
    },
  } = useStore();
  // 추천 Tag 리스트
  if (list.length > 0 || isEmpty) {
    return <SearchRecommendTagList isEmpty={isEmpty} list={list} type={type} />;
  }

  // 최근 검색어 없는 경우 return null
  if (!searches || searches.length === 0) {
    return null;
  }

  const onClickSearch = (searchValue: string) => {
    setSelectType("search");
    //Firebase Event
    const jsonParams = {
      P1: searchValue,
    };
    onUpdateCurrentSearch({
      searchValue: searchValue,
      inputValue: "",
    });
    firebaseEvent("search_recent", jsonParams);
    const encodeTag = searchValue.includes("%")
      ? encodeURIComponent(searchValue.replace(/%/gi, "percent2e5"))
      : encodeURIComponent(searchValue);
    history.push(`/search/${encodeTag}`);
  };

  // 최근 검색어
  return (
    <SearchRecommendContainer style={{ paddingTop: "56px" }}>
      <Typography variant="subtitle1" style={{ marginBottom: 12 }}>
        <TranslationJSX locoKey="feed_recent_title" />
      </Typography>
      <Grid container spacing={1}>
        {searches.map((el) => {
          const label = el.includes("comma2c")
            ? el.replace(/comma2c/gi, ",")
            : el;
          return (
            <MuiGrid item key={label}>
              <MuiChip label={label} onClick={() => onClickSearch(label)} />
            </MuiGrid>
          );
        })}
      </Grid>
    </SearchRecommendContainer>
  );
};

export default observer(SearchRecommend);
